<script setup lang="ts">
import { IonButton, IonIcon } from '@ionic/vue';

const props = defineProps({
	class: { type: String },
	fill: { type: String as () => 'default' | 'clear' | 'outline' | 'solid', default: 'solid' },
	iconLeft: { type: String },
	iconRight: { type: String },
	text: { type: String as () => string, default: '' },
	color: { type: String, default: '' },
});

const emit = defineEmits(['onClick']);

const onClick = async () => {
	emit('onClick');
};
</script>

<template>
	<ion-button :color="props.color || 'primary'" class="flex justify-between items-center w-full normal-case text-base text-anykrowd-dark" :class="props.class" :fill="props.fill" shape="round" @click="onClick">
		<ion-icon v-if="props.iconLeft" :icon="props.iconLeft" class="mr-2" :class="[props.color ? `text-${props.color}` : props.fill === 'outline' ? 'text-white' : 'text-anykrowd-dark']" />
		<span class="justify-start font-sourcesanspro-semibold" :class="props.color ? `text-${props.color}` : ''">{{ $t(props.text) }}</span>
		<ion-icon v-if="props.iconRight" :icon="props.iconRight" />
	</ion-button>
</template>

<style lang="scss" scoped>
button {
	height: 52px;
}
</style>
